import { ConfirmDeleteButton } from '@ui/modals';
import { coreActions } from '@sonar-software/sonar-core';
import { getClosestCardHeader } from '@lib/popups';
import { COPY_SPECIFIC, LINKS, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useCurrentOrganizationSubdomain, useCurrentUser } from '@hooks';
export const RevokeAccessButton = ({ applicationId }) => {
    const subdomain = useCurrentOrganizationSubdomain();
    const { isReadOnly } = useCurrentUser();
    const hideApplication = useAction(coreActions.requestDeleteCoreDataSecurityApplications);
    const handleHide = useCallback(() => {
        hideApplication({ applicationId });
        window.open(LINKS.SALESFORCE_MANAGE_APPS(subdomain), '_blank');
    }, [applicationId, hideApplication, subdomain]);
    if (isReadOnly) {
        return null;
    }
    return (React.createElement(ConfirmDeleteButton, { buttonId: 'revoke-app-button', buttonLabel: COPY_SPECIFIC.REVOKE_APP_ACCESS, cancelButtonProps: {
            value: COPY_SPECIFIC.NO
        }, className: 'confirm-hide', confirmButtonProps: {
            value: COPY_SPECIFIC.YES
        }, getPopupContainer: getClosestCardHeader, onCancel: () => window.open(LINKS.SALESFORCE_MANAGE_APPS(subdomain), '_blank'), onConfirm: handleHide, title: MESSAGES_COPY.HIDE_AS_WELL_INTEGRATION_APP, type: 'link' }));
};
